export enum WorkflowType {
    BATTERY = "battery",
    BATTERY_COUNT= "battery_count",
    WEEE = "weee"
}